export const generateUrl = (
  url: string,
  params: Record<string, string | string[] | number | number[]>,
): string => {
  const baseUrl = url;
  const queryParams: string[] = [];

  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null) {
      if (Array.isArray(value)) {
        value.forEach((val) => {
          queryParams.push(`${key}=${val}`);
        });
      } else {
        queryParams.push(`${key}=${value}`);
      }
    }
  }

  if (queryParams.length === 0) {
    return baseUrl;
  }

  return `${baseUrl}?${queryParams.join('&')}`;
};
